<ul class="breadcrumbs body-3">
  <li *ngFor="let breadcrumb of breadcrumbs$ | async; last as isLast;"
      [ngClass]="{'active': isLast}" aria-current="page">
    <a *ngIf="!isLast; else lastRoute"
       (click)="routeService.updatePrevUrl()"
       [routerLink]="[breadcrumb.url]"
       routerLinkActive="active">{{ breadcrumb.label | translate }}</a>
    <ng-template #lastRoute>{{ breadcrumb.label | translate }}</ng-template>
  </li>
</ul>
